import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { usePhieuXuatKhoTableCellApi } from './composables/usePhieuXuatKhoTableCellApi';
import {
  THU_HOI_GROUP_LABEL,
  THU_HOI_SUB_COLUMNS,
} from './composables/usePhieuXuatKhoTableColumns';
import PhieuXuatKhoVatTuThuHoiCell from './PhieuXuatKhoVatTuThuHoiCell.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PhieuXuatKhoVatTuThuHoiColumns',
  setup(__props) {

const api = usePhieuXuatKhoTableCellApi();
const isSummaryMode = api.isSummaryMode;
const thuHoiGroupLabel = THU_HOI_GROUP_LABEL;

const thuHoiSubColumnLabel = (
  id: (typeof THU_HOI_SUB_COLUMNS)[number]['id'],
  useParent = false
) => {
  const column = THU_HOI_SUB_COLUMNS.find((item) => item.id === id);

  if (useParent && column && 'parentLabel' in column) {
    return column.parentLabel;
  }

  return column?.label ?? id;
};

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!

  return (_openBlock(), _createBlock(_component_el_table_column, {
    align: "center",
    "header-align": "center",
    label: _unref(thuHoiGroupLabel)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, {
        align: _unref(isSummaryMode) ? 'right' : undefined,
        "header-align": "center",
        label: thuHoiSubColumnLabel('tai_sd'),
        prop: 'thu_hoi.tai_sd',
        "show-overflow-tooltip": !_unref(isSummaryMode),
        width: _unref(isSummaryMode) ? 80 : 100
      }, {
        default: _withCtx((scope) => [
          _createVNode(PhieuXuatKhoVatTuThuHoiCell, {
            row: scope.row,
            "sub-column-id": "tai_sd"
          }, null, 8, ["row"])
        ]),
        _: 1
      }, 8, ["align", "label", "prop", "show-overflow-tooltip", "width"]),
      _createVNode(_component_el_table_column, {
        align: _unref(isSummaryMode) ? 'right' : undefined,
        "header-align": "center",
        label: thuHoiSubColumnLabel('mat'),
        prop: 'thu_hoi.mat',
        "show-overflow-tooltip": !_unref(isSummaryMode),
        width: _unref(isSummaryMode) ? 80 : 100
      }, {
        default: _withCtx((scope) => [
          _createVNode(PhieuXuatKhoVatTuThuHoiCell, {
            row: scope.row,
            "sub-column-id": "mat"
          }, null, 8, ["row"])
        ]),
        _: 1
      }, 8, ["align", "label", "prop", "show-overflow-tooltip", "width"]),
      _createVNode(_component_el_table_column, {
        align: "center",
        "header-align": "center",
        label: thuHoiSubColumnLabel('so_luong_phe_lieu', true)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            align: _unref(isSummaryMode) ? 'right' : undefined,
            "header-align": "center",
            label: thuHoiSubColumnLabel('so_luong_phe_lieu'),
            prop: 'thu_hoi.so_luong_phe_lieu',
            "show-overflow-tooltip": !_unref(isSummaryMode),
            width: _unref(isSummaryMode) ? 80 : 100
          }, {
            default: _withCtx((scope) => [
              _createVNode(PhieuXuatKhoVatTuThuHoiCell, {
                row: scope.row,
                "sub-column-id": "so_luong_phe_lieu"
              }, null, 8, ["row"])
            ]),
            _: 1
          }, 8, ["align", "label", "prop", "show-overflow-tooltip", "width"]),
          _createVNode(_component_el_table_column, {
            align: _unref(isSummaryMode) ? 'right' : undefined,
            "header-align": "center",
            label: thuHoiSubColumnLabel('quy_doi_kg'),
            prop: 'thu_hoi.quy_doi_kg',
            "show-overflow-tooltip": !_unref(isSummaryMode),
            width: _unref(isSummaryMode) ? 100 : 120
          }, {
            default: _withCtx((scope) => [
              _createVNode(PhieuXuatKhoVatTuThuHoiCell, {
                row: scope.row,
                "sub-column-id": "quy_doi_kg"
              }, null, 8, ["row"])
            ]),
            _: 1
          }, 8, ["align", "label", "prop", "show-overflow-tooltip", "width"]),
          _createVNode(_component_el_table_column, {
            align: _unref(isSummaryMode) ? 'right' : undefined,
            "header-align": "center",
            label: thuHoiSubColumnLabel('ma_vt_thu_hoi'),
            prop: 'thu_hoi.ma_vt_thu_hoi',
            "show-overflow-tooltip": !_unref(isSummaryMode),
            width: _unref(isSummaryMode) ? 100 : 120
          }, {
            default: _withCtx((scope) => [
              _createVNode(PhieuXuatKhoVatTuThuHoiCell, {
                row: scope.row,
                "sub-column-id": "ma_vt_thu_hoi"
              }, null, 8, ["row"])
            ]),
            _: 1
          }, 8, ["align", "label", "prop", "show-overflow-tooltip", "width"])
        ]),
        _: 1
      }, 8, ["label"])
    ]),
    _: 1
  }, 8, ["label"]))
}
}

})